/**
 * Updates values of the rooming.roomingConfig store object
 * @param  {any?} [value] A complete roommingConfig item to save to local
 *                        storage and to the redux store.
 *
 */
export function updateRoomingConfig(value) {
  return {
    type: 'UPDATE_ROOMING_CONFIG',
    value
  }
}
